// frontend_react/src/components/LoadingScreen.jsx

import React from "react";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";

import logo from "../assets/logo_qg.jpeg";

const bounce = keyframes`
  0%, 100% { transform: translateY(0); opacity: 0.55; }
  50% { transform: translateY(-10px); opacity: 1; }
`;

const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.045); opacity: 0.82; }
  100% { transform: scale(1); opacity: 1; }
`;

export default function LoadingScreen({
  message = "Chargement en cours…",
}) {
  return (
    <Screen>
      <LogoWrapper>
        <Logo src={logo} alt="Logo Queens Games" />
      </LogoWrapper>

      <Dots aria-label="Chargement">
        <Dot $delay="0s" />
        <Dot $delay="0.2s" />
        <Dot $delay="0.4s" />
      </Dots>

      <Message>{message}</Message>
    </Screen>
  );
}

LoadingScreen.propTypes = {
  message: PropTypes.string,
};

const Screen = styled.div`
  min-height: 100dvh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 1.5rem;
  box-sizing: border-box;
  text-align: center;

  background:
    radial-gradient(circle at top, rgba(255, 249, 234, 0.12), transparent 34rem),
    linear-gradient(135deg, #11182b 0%, #1d263d 48%, #26324f 100%);

  color: #fff9ea;
`;

const LogoWrapper = styled.div`
  width: 6.4rem;
  height: 6.4rem;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: rgba(255, 249, 234, 0.12);
  border: 1px solid rgba(255, 249, 234, 0.22);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.28);
  animation: ${pulse} 2.4s infinite ease-in-out;
`;

const Logo = styled.img`
  width: 5.1rem;
  height: 5.1rem;
  object-fit: cover;
  border-radius: 999px;
`;

const Dots = styled.div`
  display: flex;
  margin-top: 1.6rem;
  gap: 0.55rem;
`;

const Dot = styled.span`
  width: 0.72rem;
  height: 0.72rem;
  border-radius: 999px;
  background: #fff9ea;
  animation: ${bounce} 1.35s infinite ease-in-out;
  animation-delay: ${({ $delay }) => $delay};
`;

const Message = styled.p`
  margin: 1.1rem 0 0;
  color: rgba(255, 249, 234, 0.88);
  font-size: 0.95rem;
  font-weight: 800;
  letter-spacing: 0.01em;
`;